import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Flex, Text, Badge, Link, Button } from '@chakra-ui/react';
import { cqAPI } from '../../lib/Auth';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon component
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from "../../AppContext";

function MonitoringCallDetail() {
  const { prevLocation } = useAppContext()
  const { callId } = useParams();
  const [callDetails, setCallDetails] = useState({
    callObj: {}
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate()
  const [audioSrc, setAudioSrc] = useState('')
  let file_url;


  const fetchCallDetails = async () => {
    try {
      const response = await cqAPI.get(`/monitoring/call?id=${callId}`);
      setCallDetails(response.data);
      const recordings = response.data?.callObj?.recordings ?? [];
      const full_recording = recordings.find(rec => rec.type === "full") ?? recordings.find(rec => rec.type === "unknown") ?? null;
      if (full_recording) {

        // show the full recording if it exists in recordings
        file_url = full_recording.file_obj;
      }
      else if (response.data?.callObj?.recording_file_obj){
        file_url = response.data.callObj.recording_file_obj;
      }
      if (file_url) {
        setAudioSrc(await cqAPI.downloadFile(file_url).catch(e => null));
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching call details:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCallDetails();
  }, [callId]);

  if (loading) {
    return <Box>Loading...</Box>;
  }

  const formatDate = (date) => {
    return moment(date).format('LLL');
  };

  const handleBackClick = () => {
      navigate(-1);
    };

    const downloadFile = async (attachmentUrl, fileName) => {
      try {

        // Create a temporary link element and trigger the download
        const link = document.createElement('a');
        link.href = audioSrc
        link.setAttribute('download', fileName); // Set the file name for the download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Failed to download file:', error);
      }
    };

  return (
    <Flex direction="column" p="5" overflowY="auto" maxH="100vh"> {/* Enable scrolling */}
      <Box className="call-details" w="100%" textAlign="left">
    <Box textAlign="left" mb="5">
        {prevLocation === '/monitoring/calls' && (
          <Button onClick={handleBackClick} variant="ghost">
            <FontAwesomeIcon icon={faArrowLeft} />
            Back to call list
          </Button>
        )}
      </Box>
        {!callDetails?.callObj && "Could not find a recording for this call"}
        { callDetails?.callObj &&
        <Flex wrap="wrap">
          <Box p="2" w="200px">
            <Text fontWeight="bold">Phone #</Text>
            <Text >{callDetails.callObj?.type === 'Incoming' ? callDetails?.callObj?.from : callDetails?.callObj?.to}</Text>
            {callDetails?.callObj?.name ? (
              <Text>{callDetails?.callObj?.name}</Text>
            ) : callDetails?.patient_name ? (
              <Text>{callDetails?.patient_name}</Text>
            ) : ""}
          </Box>

          <Box p="2" w="200px">
            <Text fontWeight="bold">Date & Time</Text>
            <Text>{formatDate(callDetails?.callObj?.created)}</Text>
          </Box>

          <Box p="2" w="200px">
            <Text fontWeight="bold">Duration</Text>
            <Text>{callDetails?.callObj?.duration}</Text>
          </Box>

          <Box p="2" w="200px">
            <Text fontWeight="bold">Business Name</Text>
            <Text>
              {callDetails?.business_name}
            </Text>
          </Box>
          <Box p="2" w="200px">
            <Text fontWeight="bold">Conversation topics</Text>
            {callDetails?.callObj?.metadata_transcriptions.conversation_topics.map((topic, i) => (
              <li key={i}>{topic}</li>
            ))}
          </Box>
          <Box p="2" w="200px">
            <Text fontWeight="bold">metadata transcriptions</Text>
            {callDetails?.callObj?.metadata_transcriptions.goals_score.map((score, i) => (
              <Text key={i}>
                {score}: {callDetails?.callObj?.metadata_transcriptions.goals_score_reason[i] ?? '—'}
              </Text>
            ))}
          </Box>
          <Box p="2" w="200px">
            <Text fontWeight="bold">Conversation goals</Text>
            {callDetails?.callObj?.metadata_transcriptions.conversation_goals.map((goal, i) => (
              <li key={i}> {goal} </li>
            ))}
          </Box>

          {file_url !== null && (
            <Box p="2" w="300px">
              <Text fontWeight="bold">Recording</Text>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  downloadFile(file_url, `${(callDetails?.callObj?.name || '').toLowerCase().replace(/\ /g, '-') || callDetails?.callObj}.wav`);
                }}
                cursor="pointer"
              >
                Download
              </Link>
              <audio controls style={{ width: '100%', marginTop: '10px' }}>
                <source src={audioSrc} type="audio/mpeg"/>
                Your browser does not support the audio element.
              </audio>
            </Box>
          )}

          {callDetails?.transcription && callDetails?.transcription?.indicators && (
            <Box p="2" w="200px">
              <Text fontWeight="bold">Indicators</Text>
              {callDetails.transcription?.indicators.map((indicator, index) => (
                <Badge key={index} colorScheme="green" m="1">
                  {indicator}
                </Badge>
              ))}
            </Box>
          )}
        </Flex>
        }
        <Box mt="4">
          <Text fontSize="2xl" mb="2">Transcription</Text>
          {callDetails?.timelineObj && callDetails?.timelineObj.length ? (
            callDetails.timelineObj.map((item, index) => (
              item && (
                <Box key={index} p="2">
                  <Text color={item.chan === 'Agent' ? 'blue.500' : 'green.500'}>
                    <strong>{item.chan}: </strong>{item.content}
                  </Text>
                </Box>
              )
            ))
          ) : (callDetails?.transcription?.raw_data?.results?.transcripts?.length) ? (
                <Box p="2" w="1000px">
                  <Text color='green.500' m="1">
                    {callDetails.transcription.raw_data.results.transcripts[0].transcript}
                  </Text>
                </Box>
            ) : (
            <Text>Not available</Text>
          )}
        </Box>
      </Box>
    </Flex>
  );
}

export default MonitoringCallDetail;
